// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Specular_Internal_Incremental_Global from "../Specular.Internal.Incremental.Global/index.js";
import * as Specular_Internal_Incremental_Mutable from "../Specular.Internal.Incremental.Mutable/index.js";
import * as Specular_Internal_Incremental_MutableArray from "../Specular.Internal.Incremental.MutableArray/index.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular_Internal_Incremental_Ref from "../Specular.Internal.Incremental.Ref/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var valueExc = function (node) {
    var value_opt = $foreign.get_value(node);
    return Specular_Internal_Incremental_Optional.fromSome(value_opt);
};
var toSomeNodeArray = Unsafe_Coerce.unsafeCoerce;
var toSomeNode = Unsafe_Coerce.unsafeCoerce;
var refcount = function (node) {
    var observers = $foreign.get_observers(node);
    var numDependents = Specular_Internal_Incremental_MutableArray.length(observers);
    var dependents = $foreign.get_dependents(node);
    var numObservers = Specular_Internal_Incremental_MutableArray.length(dependents);
    return numDependents + numObservers | 0;
};
var name = function (node) {
    return Effect_Unsafe.unsafePerformEffect(function () {
        return $foreign.get_name(node);
    });
};
var isChangingInCurrentStabilization = function (node) {
    var currentStabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum);
    var changedAt = $foreign.get_changedAt(node);
    return changedAt === currentStabilizationNum;
};
var create = function (source) {
    var dependents = Specular_Internal_Incremental_MutableArray.empty();
    var observers = Specular_Internal_Incremental_MutableArray.empty();
    return $foreign["_new"](Specular_Internal_Incremental_Optional.none, source, dependents, observers, Specular_Internal_Incremental_Optional.none, 0);
};
var annotate = /* #__PURE__ */ (function () {
    if (Specular_Internal_Profiling.enabled) {
        return $foreign.set_name;
    };
    return function (v, v1) {
        return Data_Unit.unit;
    };
})();
export {
    _new,
    get_adjustedHeight,
    get_changedAt,
    get_dependents,
    get_height,
    get_name,
    get_observers,
    get_source,
    get_value,
    set_adjustedHeight,
    set_changedAt,
    set_height,
    set_name,
    set_value
} from "./foreign.js";
export {
    annotate,
    create,
    isChangingInCurrentStabilization,
    name,
    refcount,
    toSomeNode,
    toSomeNodeArray,
    valueExc
};
export {
    Field
} from "../Specular.Internal.Incremental.Mutable/index.js";
